import React from 'react';
import { Users, Zap, Award, CheckCircle, RefreshCw, Truck } from 'lucide-react';
import { whyChooseUs, images } from '../data/mock';

const iconMap = {
  Users: Users,
  Zap: Zap,
  Award: Award,
  CheckCircle: CheckCircle,
  RefreshCw: RefreshCw,
  Truck: Truck
};

export const WhyChooseUs = () => {
  return (
    <section id="about" className="py-24 bg-black relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-purple-500/20">
              <img 
                src={images.tools} 
                alt="Professional car workshop" 
                className="w-full h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
            </div>
            
            {/* Floating Badge */}
            <div className="absolute -bottom-8 -right-8 bg-gradient-to-br from-purple-600 to-pink-600 p-8 rounded-2xl shadow-2xl shadow-purple-500/50">
              <div className="text-center">
                <div className="text-5xl font-bold text-white mb-2">5.0</div>
                <div className="flex gap-1 mb-2">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} className="w-6 h-6 text-yellow-400 fill-current" viewBox="0 0 20 20">
                      <path d="M10 15l-5.878 3.09 1.123-6.545L.489 6.91l6.572-.955L10 0l2.939 5.955 6.572.955-4.756 4.635 1.123 6.545z" />
                    </svg>
                  ))}
                </div>
                <div className="text-white text-sm font-semibold">Google Betyg</div>
              </div>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Varför Välja <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-400">Oss?</span>
            </h2>
            <p className="text-gray-400 text-lg mb-8 leading-relaxed">
              Gävles Autodepå är din pålitliga partner för snabb och smidig bilservice i Gävle. 
              Med personlig kontakt och hög kvalitet till bra priser hjälper vi dig hålla din bil i toppskick.
            </p>

            {/* Business Trust Section */}
            <div className="bg-gradient-to-r from-purple-600/20 to-pink-600/20 border-l-4 border-purple-500 p-6 rounded-lg mb-8">
              <h3 className="text-white text-xl font-bold mb-3 flex items-center gap-2">
                <svg className="w-6 h-6 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                Företag Litar på Oss
              </h3>
              <p className="text-gray-300 leading-relaxed">
                Vi samarbetar med företag som har många bilar i sin verksamhet och ansvarar för service och reparationer av deras fordon. 
                Våra kunder litar på oss för snabb, pålitlig och professionell service.
              </p>
            </div>

            {/* Key Highlight */}
            <div className="bg-gradient-to-r from-purple-600/20 to-pink-600/20 border-l-4 border-purple-500 p-6 rounded-lg mb-12">
              <p className="text-white text-lg font-semibold">
                💡 Vi kommer till dig! Vår rullande bilverkstad gör det enkelt – vi fixar din bil där du är.
              </p>
            </div>

            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {whyChooseUs.map((item, index) => {
                const Icon = iconMap[item.icon];
                return (
                  <div 
                    key={item.id}
                    className="group bg-gradient-to-br from-gray-900/50 to-gray-800/50 p-6 rounded-xl border border-gray-700/50 hover:border-purple-500/50 transition-all duration-300 hover:shadow-lg hover:shadow-purple-500/20"
                  >
                    <div className="flex items-start gap-4">
                      <div className="w-12 h-12 bg-gradient-to-br from-purple-600/20 to-pink-600/20 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform duration-300">
                        <Icon size={24} className="text-purple-400" />
                      </div>
                      <div>
                        <h3 className="text-white font-bold mb-2">{item.title}</h3>
                        <p className="text-gray-400 text-sm">{item.description}</p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
